// extracted by mini-css-extract-plugin
export var axis = "Plot-module--axis--d7dde";
export var axisLabel = "Plot-module--axisLabel--5e65e";
export var background = "Plot-module--background--7801f";
export var container = "Plot-module--container--c5711";
export var focused = "Plot-module--focused--3d639";
export var point = "Plot-module--point--b83f7";
export var pointFocused = "Plot-module--pointFocused--c7c70";